import React from 'react'
import { Heading, GContainer, Seachbar, Input, CustomBsSearch } from '../../style/Navbar'
import { CustomDiv } from '../../style/shared'
import { SettingIcon } from '../../style/Home'
import Setting from "../../assets/Pmc/setting.svg";
import { Grid } from '@material-ui/core';
import { Logo1, Logo2 } from '../logo/Logo';
import { Sidebar } from "../Sidebar/Sidebar";
import Cal from "../../assets/sidebar/calendar.svg";
import User from "../../assets/sidebar/user.svg";
import Menu from "../../assets/sidebar/menu.svg";
import Person from "../../assets/sidebar/person.svg";
import CalA from "../../assets/sidebar/calendarA.svg";
import UserA from "../../assets/sidebar/userA.svg";
import MenuA from "../../assets/sidebar/menuA.svg";
import PersonA from "../../assets/sidebar/personA.svg";

export const sidebarConfig = [
    {
      path: "/Calender",
      icon: Cal,
      activeIcon: CalA,
      alt: "Cal",
    },
    {
      path: "/People/dashboard",
      icon: User,
      activeIcon: UserA,
      alt: "User",
    },
    {
      path: "",
      icon: Menu,
      activeIcon: MenuA,
      alt: "Menu",
    },
    {
      path: "",
      icon: Person,
      activeIcon: PersonA,
      alt: "Person",
    },
  ];

export const Navbar = (props) => {
    { console.log(props, "here is props value", props.Heading) }
    return (
        <GContainer className='noPadd'>
            <Grid container>
                <Grid item md={12} xs={12} className='hideMain'>
                    <Grid container>
                        <Grid item md={2} sm={2} lg={2} className='mobileCss mobCenter'>
                            <Heading>
                                {props.Heading ? props.Heading : "Patient chart"}
                            </Heading>
                        </Grid>
                        <Grid item md={6} sm={5} lg={8} className='mobileCss mobCenter  mobP-LR'>

                            <Seachbar>
                                <CustomBsSearch />
                                <Input placeholder="Search" />
                            </Seachbar>
                        </Grid>
                        <Grid item md={4} sm={5} lg={2} className='mobileCss mobCenter'>
                            <div className='w6-text-center' style={{ fontSize: "16px", marginTop: "20px", textAlign: "right", paddingRight: "12px", fontWeight: 600, fontFamily: 'Montserrat SemiBold,"Open Sans",Helvetica,Arial,sans-serif !important' }}>Provider: TOM COLLINS</div>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12} className='showMain'>
                    <div style={{ textAlign: "right" }} className='settingIcon'>
                        <SettingIcon src={Setting} alt="setting" onClick={props.handleSettingClick} />
                    </div>
                </Grid>
            </Grid>
           
        </GContainer >
    )
}
